import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Notification } from 'src/app/core/Notifications/Notification';
import { ServiceService } from '../../service.service';

@Component({
  selector: 'app-ar-reschedule',
  templateUrl: './ar-reschedule.component.html',
  styleUrls: ['./ar-reschedule.component.scss']
})
export class ArRescheduleComponent implements OnInit {
  select_date: any;
  select_FrmTime: any;
  select_toTime: any;

  constructor(@Inject(MAT_DIALOG_DATA) private _data: any, private service:ServiceService, private notif:Notification) {
    this.select_date = this._data.d.select_date;
    this.select_FrmTime= this._data.d.select_FrmTime;
    this.select_toTime= this._data.d.select_toTime;
   }

   
  ngOnInit(): void {

  }

  accept(){
    var acceptData = {
      "appt_Id": this._data.d.appt_Id,
      "patient_id":  this._data.d.appt_PatientId_FK
    }
    this.service.accept(acceptData)
    // .subscribe((res)=>{
    //   this.notif.successmsg("Reschedule Accepted")
    // },(error)=>{
    //     this.notif.errorsmsg(error)
    // })
    .subscribe({
      next: (res) => {
        this.notif.successmsg("Reschedule Accepted");
        window.location.reload();
      },
      error: (error) => {
        this.notif.errorsmsg('An error occurred while accepting.');
        console.error('Error:', error);
      }
    });
  }

  reject(){
    var rejectData = {
      "appt_Id": this._data.d.appt_Id,
      "phc_Appt_Id":  this._data.d.phc_Appt_Id
    }
    this.service.reject(rejectData)
    .subscribe({
      next: (res) => {
        this.notif.successmsg("Reschedule Rejected");
        window.location.reload();
      },
      error: (error) => {
        this.notif.errorsmsg('An error occurred while accepting.');
        console.error('Error:', error);
      }
    });
  }
}
